// assets
import {
  DashboardOutlined,
  TeamOutlined,
  HomeOutlined,
  CloudServerOutlined,
  CreditCardOutlined,
  GiftOutlined,
  UsergroupAddOutlined,
  SettingOutlined
} from '@ant-design/icons';

// icons
const icons = {
  DashboardOutlined,
  TeamOutlined,
  HomeOutlined,
  CloudServerOutlined,
  CreditCardOutlined,
  GiftOutlined,
  UsergroupAddOutlined,
  SettingOutlined
};

// ==============================|| MENU ITEMS - PRIVACYPAL PARTNER PORTAL ||============================== //

const navigation = {
  id: 'group-portal',
  title: 'Partner Portal',
  type: 'group',
  children: [
    {
      id: 'dashboard',
      title: 'Dashboard',
      type: 'item',
      url: '/dashboard',
      icon: icons.DashboardOutlined,
      breadcrumbs: false
    },
    {
      id: 'customers',
      title: 'Customers',
      type: 'item',
      url: '/customers',
      icon: icons.TeamOutlined,
      breadcrumbs: false
    },
    {
      id: 'families',
      title: 'Families',
      type: 'item',
      url: '/families',
      icon: icons.HomeOutlined,
      breadcrumbs: false
    },
    {
      id: 'family-trials',
      title: 'Family Trials',
      type: 'item',
      url: '/family-trials',
      icon: icons.UsergroupAddOutlined,
      breadcrumbs: false,
      // Grants Family to a partner's households with no card, and can create
      // Stripe invoices. Administrator-only; the route and family-api refuse
      // members independently.
      adminOnly: true
    },
    {
      id: 'max-trials',
      title: 'Trials',
      type: 'item',
      url: '/trials',
      icon: icons.GiftOutlined,
      breadcrumbs: false,
      // Issuing a trial code is issuing entitlement: an enterprise code grants
      // Max company-wide with no card. Administrator-only, and the route and
      // the API refuse members independently.
      adminOnly: true
    },
    {
      id: 'status',
      title: 'Status',
      type: 'item',
      url: '/status',
      icon: icons.CloudServerOutlined,
      breadcrumbs: false
    },
    {
      id: 'billing',
      title: 'Billing',
      type: 'item',
      url: '/billing',
      icon: icons.CreditCardOutlined,
      breadcrumbs: false
    },
    {
      id: 'settings',
      title: 'Settings',
      type: 'item',
      url: '/settings',
      icon: icons.SettingOutlined,
      breadcrumbs: false,
      // Portal users, platform connection and Stripe billing. Navigation filters
      // this out for members; the route and the API refuse them independently.
      adminOnly: true
    }
  ]
};

export default navigation;
